import {Api} from './config/request';
import {
    labelsDefault,
    sharePriceDefault,
    signalsDefault,
    financialDataDefault,
    criticalDataDefault,
    stockConsensusData,
} from './const';

export const getSharePrice = (entityId, entityType, ric) => {
    return Api.postRequest('getShortlistingEntityInfo', {
        entityIds: entityId,
        entityType,
        ric,
        selected: ric,
    });
};
// export const getSharePrice = (id, payload = sharePriceDefault) => {
//   return Api.postRequest("sharePriceInfo", { ...payload, companyId: id });
// };
export const getShareLabels = (payload = labelsDefault) => {
    return Api.postRequest('displayContent', payload);
};
const getCompanySignals = (payload, p = signalsDefault) =>
    Api.postRequest('companySignals', {...p, ...payload});

const getFinancialData = (id, p = financialDataDefault) =>
    Api.getRequest(
        //payload.templateGroup = "ResearchWise Financials";
        `financialData?companyId=${id}&startYear=${p.startYear}&endYear=${p.endYear}&templateGroup=ResearchWise Financials,DBS Financials`,
        {
            resType: 'json',
        },
    );

const getCriticalFactors = (id, type, p = criticalDataDefault) =>
    Api.getRequest(`criticalFactorsInfo?entityId=${id}&entityType=${type}`, {
        resType: 'json',
    });
const getCriticalFactorsNew = (
    id,
    type,
    enabledOnly,
    p = criticalDataDefault,
) =>
    Api.getRequest(
        `getCriticalFactors?entityId=${id}&entityType=${type}&enabledOnly=${enabledOnly}`,
        {
            resType: 'json',
        },
    );
const getEntityUiInfo = (id, type, p = criticalDataDefault) => {
    if (type === 'Industry' || type === 'Country') {
        type += 'Template';
    }
    return Api.getRequest(`getEntityUIInfo?entityId=${id}&entityType=${type}`, {
        resType: 'json',
    });
};
const getStockConsensus = (id, p = stockConsensusData) =>
    Api.getRequest(
        `stockPriceConsensus?ric=${id}&startDate=${p.startDate}&endDate=${p.endDate}`,
        {
            resType: 'json',
        },
    );

const getShareRatioData = (p) => Api.postRequest('shareRatioInfo', p);

// const getCompleteView = (p=stockConsensusData) => Api.postRequest('completeView', p)
const getCompleteViewSummary = (p = stockConsensusData) =>
    Api.postRequest('completeViewSummary', p);

const getCriticalFactorNews = (p) => Api.postRequestTemp('getCFSignalData', p);
const getCriticalFactorNewsCount = (p) =>
    Api.postRequestTemp('getCFSignalDataCount', p);

// const getCriticalFactorInfo = (p = {}) => Api.postRequest('criticalFactorsInfo', p)

const getImpactAnalysisData = (p) => Api.postRequest('getImpactAnalysis', p);

const getEpsRatioData = (p = stockConsensusData) =>
    Api.postRequest('shareRatioInfo', p);
const getSpecificCompanySignals = (p = signalsDefault) =>
    Api.postRequest('companySignals', p);
// const getNetworkData = (p) => Api.postRequest('extendedGraphView', p)
const getNetworkData = (p) => Api.postRequest('graphView', p);
const getNetworkEntitySignals = (p) => Api.postRequest('companySignals', p);
const getNetworkEntityCriticalFactors = (p) =>
    Api.postRequest('criticalFactorSignal', p);
const getCriticalFactorGraphData = (p) =>
    Api.postRequest('criticalFactorDataImpact', p);
const getGraphViewCompanyEntity = (Obj) =>
    Api.postRequest('graphViewCompanyEntity', Obj);
const getRatioInfo = (ric) =>
    Api.getRequest(`getRatioInfo?ric=${ric}`, {resType: 'json'});
const getCloversData = (entityId) =>
    Api.getListRequest(
        `getCloversData?entityId=${entityId}&entityType=Company`,
        {resType: 'json'},
    );
const getPCompanyRatioInfo = (companyId) =>
    Api.getRequest(`getPCompanyRatioInfo?companyId=${companyId}`, {
        resType: 'json',
    });
export const getImage = (imageId) =>
    Api.getRequest(
        `getS3Files?fileId=${imageId}&fileGroup=Chart&fileType=image`,
        {resType: 'json'},
    );

export const getStructuredDataNew = (p) =>
    Api.postRequest('getStructuredData', p);
export const getStructuredData = (p) => Api.postRequest('getStructuredData', p);

const getRecentDevelopmentPartial = (p) =>
    Api.getRequest(`getPartialUiWhatsNew?entityId=${p}&limited=false`, {
        resType: 'json',
    });
const getRecentDevelopment = (p) =>
    Api.getRequest(`getUiWhatsNew?entityId=${p}&limited=false`, {
        resType: 'json',
    });
const getLimitedRecentDevelopment = (p) =>
    Api.getRequest(`getUiWhatsNew?entityId=${p}&limited=true`, {
        resType: 'json',
    });
const getLimitedRecentDevelopmentPartial = (p) =>
    Api.getRequest(`getPartialUiWhatsNew?entityId=${p}&limited=true`, {
        resType: 'json',
    });
const getRecentDevUrls = (p) => {
    if (!p.entityType) {
        p.entityType = 'Company';
    }
    return Api.getListRequest(
        `getWhatsNewData?entityId=${p.companyId}&entityType=${p.entityType}`,
    );
};
const getRecentDevCountryUrls = (p) =>
    Api.getListRequest(
        `getWhatsNewData?entityId=${p.companyId}&entityType=CountryTemplate`,
    );
const getRecentDevIndustryUrls = (p) =>
    Api.getListRequest(
        `getWhatsNewData?entityId=${p.companyId}&entityType=IndustryTemplate`,
    );

export const getSignalList = (p) => {
    if (p.companyId) {
        p.entityId = p.companyId;
        delete p['companyId'];
    }
    if (p.entityType === 'Industry' || p.entityType === 'Country') {
        p.entityType += 'Template';
    }
    return Api.postRequest('getSignalData', p);
};
export const getSignalCounts = (p) => {
    if (p.companyId) {
        p.entityId = [p.companyId];
        delete p['companyId'];
    }
    if (p.entityType === 'Industry' || p.entityType === 'Country') {
        p.entityType += 'Template';
    }
    return Api.postRequestTemp('getSignalDataCount', p);
};
export const getFieldList = (_) =>
    Api.getListRequest('getFieldList?group=SignalEntityType');
export const setSignalReview = (_) => Api.postRequest('addSignalReviewPost', _);

export const getCopyDotData = (p) => Api.postRequestTemp('copyDotPlotData', p);
export const getStrMappingData = (id) =>
    Api.getListRequest(`getStrMappingData?criticalFactorId=${id}`);
export const getPublishDbsView = (id) =>
    Api.getListRequest(`getCFView?cfId=${id}&publishOnly=true`);
export const getIndustryInfo = (id) => {
    return Api.postRequest('getShortlistingEntityInfo', {
        entityIds: id,
        entityType: 'IndustryTemplate',
    });
};
const fetchSharePrice = (p) =>
    Api.getRequest(`getSharePrice?ric=${p.ric}&forDate=${p.date}`, {
        resType: 'json',
    });

const getEntityRecommendation = (query) =>
    Api.getListRequest(`getEntityRecommendation?${query}`);

const CompanyApi = {
    getSharePrice,
    getPublishDbsView,
    getShareLabels,
    getCompanySignals,
    getFinancialData,
    getCriticalFactors,
    getStockConsensus,
    getShareRatioData,
    // getCompleteView,
    getCompleteViewSummary,
    getCriticalFactorNews,
    getCriticalFactorNewsCount,
    // getCriticalFactorInfo,
    getImpactAnalysisData,
    getEpsRatioData,
    getSpecificCompanySignals,
    getNetworkData,
    getNetworkEntitySignals,
    getNetworkEntityCriticalFactors,
    getCriticalFactorGraphData,
    getGraphViewCompanyEntity,
    getImage,
    getStructuredData,
    getRecentDevelopment,
    getSignalList,
    getSignalCounts,
    getFieldList,
    setSignalReview,
    getCopyDotData,
    getStrMappingData,
    getRatioInfo,
    fetchSharePrice,
    getRecentDevUrls,
    getEntityRecommendation,
    getPCompanyRatioInfo,
    getLimitedRecentDevelopment,
    getCriticalFactorsNew,
    getEntityUiInfo,
    getRecentDevelopmentPartial,
    getLimitedRecentDevelopmentPartial,
    getRecentDevCountryUrls,
    getRecentDevIndustryUrls,
    getCloversData,
};

export default CompanyApi;
